"use strict";
import { YStack, styled } from "tamagui";
import { FOCUS_SCALE } from "ui/src/components/buttons/Button/components/CustomButtonFrame/constants";
import { withCommonPressStyle } from "ui/src/components/buttons/Button/components/CustomButtonFrame/utils";
import { isTestEnv } from "utilities/src/environment/env";
import { isWeb } from "utilities/src/platform";
export const TouchableAreaFrame = styled(YStack, {
  name: "TouchableArea",
  tag: "div",
  role: "button",
  group: true,
  // TODO(MOB-2826): tests are picking up weird animationStyle on snapshots
  animation: isTestEnv() ? void 0 : "simple",
  animateOnly: isTestEnv() ? void 0 : ["transform", "opacity"],
  pressStyle: withCommonPressStyle({}),
  // borderRadius: '$rounded12',
  backgroundColor: "$transparent",
  "$platform-web": {
    containerType: "normal"
  },
  focusVisibleStyle: {
    scaleX: FOCUS_SCALE,
    scaleY: FOCUS_SCALE,
    outlineWidth: 1,
    outlineOffset: 1,
    outlineStyle: "solid"
  },
  cursor: "pointer",
  variants: {
    centered: {
      true: {
        alignItems: "center",
        justifyContent: "center"
      }
    },
    row: {
      true: {
        flexDirection: "row"
      },
      false: {
        flexDirection: "column"
      }
    },
    disabled: {
      true: {
        "aria-disabled": true,
        userSelect: "none",
        opacity: 0.6,
        pointerEvents: "box-none",
        tabIndex: -1,
        cursor: "default",
        "$platform-web": {
          pointerEvents: "none"
        }
      }
    },
    hoverable: {
      // when true, `hoverStyle` is applied via the variant
      true: {},
      // when false, `hoverStyle` is disabled
      false: {
        hoverStyle: void 0
      }
    },
    variant: {
      unstyled: {
        pressStyle: {
          scale: 1
        },
        focusVisibleStyle: {
          outlineColor: "$neutral3"
        }
      },
      none: (_, { props: { hoverable } }) => ({
        hoverStyle: hoverable ? {
          backgroundColor: "$surface2Hovered"
        } : void 0,
        focusVisibleStyle: {
          backgroundColor: "$surface2Hovered",
          outlineColor: "$neutral3"
        }
      }),
      outlined: (_, { props: { hoverable } }) => ({
        borderWidth: 1,
        borderColor: "$surface3",
        hoverStyle: hoverable ? {
          borderColor: "$surface3Hovered",
          backgroundColor: "$surface2Hovered"
        } : void 0,
        focusVisibleStyle: {
          borderColor: "$surface3Hovered",
          backgroundColor: "$surface2Hovered",
          outlineColor: "$neutral3"
        }
      }),
      filled: (_, { props: { hoverable } }) => ({
        backgroundColor: "$surface3",
        hoverStyle: hoverable ? {
          borderColor: "$surface3Hovered",
          backgroundColor: "$surface3Hovered"
        } : void 0,
        focusVisibleStyle: {
          borderColor: "$surface3Hovered",
          backgroundColor: "$surface3Hovered",
          outlineColor: "$neutral3"
        }
      }),
      raised: (_, { props: { hoverable, disabled } }) => {
        return {
          // We can't nest `$theme-[dark/light]` within `$platform-web` because Tamagui doesn't support it
          "$theme-dark": {
            boxShadow: disabled ? void 0 : isWeb ? `0px 1px 6px 2px rgba(0, 0, 0, 0.54), 0px 1px 2px 0px rgba(0, 0, 0, 0.40)` : void 0,
            shadowColor: disabled ? void 0 : isWeb ? "rgba(0,\xA00,\xA00,\xA00.40)" : void 0
          },
          "$theme-light": {
            boxShadow: disabled ? void 0 : isWeb ? `0px 1px 6px 2px rgba(0, 0, 0, 0.03), 0px 1px 2px 0px rgba(0, 0, 0, 0.02)` : void 0,
            shadowColor: disabled ? void 0 : isWeb ? "rgba(0,\xA00,\xA00,\xA00.02)" : void 0
          },
          "$platform-native": disabled ? {} : {
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 3,
            shadowColor: "$black"
          },
          "$platform-android": disabled ? {} : {
            elevation: 1
          },
          borderWidth: 1,
          borderColor: "$surface3",
          hoverStyle: hoverable ? {
            borderColor: "$surface3Hovered"
          } : void 0,
          focusVisibleStyle: {
            borderColor: "$surface3Hovered",
            outlineColor: "$neutral3"
          },
          backgroundColor: disabled ? "$surface2" : void 0
        };
      },
      floating: (_, { props: { hoverable } }) => ({
        backgroundColor: "$surface5",
        "$platform-web": {
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)"
          // for Safari
        },
        hoverStyle: hoverable ? {
          backgroundColor: "$surface5Hovered"
        } : void 0,
        focusVisibleStyle: {
          backgroundColor: "$surface5Hovered",
          outlineColor: "$neutral3"
        }
      })
    }
  },
  defaultVariants: {
    variant: "none",
    centered: false,
    hoverable: true,
    row: false
  }
});
